import { EmptyState } from 'app/agriculture/components/EmptyState/EmptyState';
import { TimelineContent } from 'app/agriculture/AgTimeline/TimelineContent';
import './TimelineEmptyState.scss';

interface TimelineEmptyStateProps {
    message?: string;
}

export function TimelineEmptyState({ message }: TimelineEmptyStateProps) {
    return (
        <TimelineContent.Row className="TimelineEmptyState">
            <TimelineContent.Main>
                <EmptyState theme="dark" message={message} />
            </TimelineContent.Main>
        </TimelineContent.Row>
    );
}
